import { FeeTypeType } from '../../types/index';
import { addFeeType } from "actions/Utilities/Policy";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useAddFeeType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (feeTypeNewData: FeeTypeType) => addFeeType(feeTypeNewData),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(["GetFeeTypes"]);
        toast.fire("Success", "Fee Type Added Successfully", "success");
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add Fee Type", "error");
      },
    }
  );

  return mutate;
};
export default useAddFeeType;
